var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_523_2430)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.727295,
    width: 53,
    height: 53,
    rx: 9.63636,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_2430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4567 26.1239C34.4938 30.1341 37.9735 31.4683 38.0122 31.4852C37.9827 31.5796 37.4562 33.3866 36.1789 35.2543C35.0752 36.8684 33.9293 38.4765 32.1238 38.5102C30.3502 38.5431 29.7798 37.4584 27.7519 37.4584C25.7239 37.4584 25.0911 38.4774 23.412 38.5431C21.6696 38.6088 20.3426 36.7976 19.2296 35.1894C16.9556 31.899 15.2166 25.8929 17.5513 21.838C18.7106 19.8245 20.7833 18.5493 23.0328 18.5164C24.744 18.4835 26.3583 19.6677 27.4047 19.6677C28.4512 19.6677 30.4126 18.2433 32.4759 18.4532C33.3395 18.4894 35.7643 18.8021 37.3205 21.082C37.195 21.1595 34.4281 22.771 34.4576 26.1239M31.1237 16.277C32.0488 15.1568 32.6714 13.5976 32.5012 12.0459C31.1675 12.0998 29.5557 12.9351 28.5994 14.0544C27.7426 15.0456 26.9919 16.6326 27.1941 18.1531C28.6803 18.2677 30.1986 17.3979 31.1237 16.277Z",
    fill: "#A8A8A8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_523_2430",
    x: 0.727295,
    y: 0,
    width: 54.2045,
    height: 54.2045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.20455,
    dy: 1.20455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.21591
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_523_2430"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_2430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5689,
    height: 26.4989,
    fill: "white",
    transform: "translate(16.4429 12.0459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadApple);
export default __webpack_public_path__ + "static/media/download_apple.dece2a05b6165ca6a72776d7d83a7994.svg";
export { ForwardRef as ReactComponent };